/**
 * ref (affiliate) 값에 따라 상품 카드의 affiliate 라벨 표시/숨김.
 * JSON 소스: (1) script[data-affiliate-coupons-json].textContent (2) 폴백 product-card[data-affiliate-coupons] 속성.
 *
 * 디버깅: URL에 ?ref_debug=1 붙이거나 localStorage.setItem('ref_debug','1') 후 새로고침
 */
(function () {
  var styleCouponsAdded = {};
  var debug = false;
  function checkDebug() {
    if (typeof URLSearchParams !== 'undefined' && new URLSearchParams(document.location.search).get('ref_debug') === '1') return true;
    try { return localStorage.getItem('ref_debug') === '1'; } catch (e) { return false; }
  }
  function log() {
    if (!debug) return;
    console.log.apply(console, ['[ref-affiliate]'].concat(Array.prototype.slice.call(arguments)));
  }

  /** HTML 속성에 &quot; 등으로 인코딩된 경우 복원 (폴백용) */
  function decodeAttrJson(str) {
    if (!str || typeof str !== 'string') return str;
    return str.replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  }

  function getRef() {
    var urlParams = new URLSearchParams(window.location.search);
    var ref = urlParams.get('ref');
    if (ref) return ref.trim();
    ref = ('; ' + document.cookie).split('; ref=').pop().split(';')[0].trim();
    if (ref) return ref;
    ref = typeof localStorage !== 'undefined' ? localStorage.getItem('ref') : null;
    return ref ? ref.trim() : null;
  }

  function setLabelVisibility(card, showCouponName) {
    var labels = card.querySelectorAll('.grid-view-ref-special-label[data-coupon-name]');
    var showRef = showCouponName ? String(showCouponName).toLowerCase() : '';
    labels.forEach(function (label) {
      var couponName = label.getAttribute('data-coupon-name');
      var show = showRef && couponName && couponName.toLowerCase() === showRef;
      if (show) {
        label.style.setProperty('display', 'inline-block', 'important');
      } else {
        label.style.setProperty('display', 'none', 'important');
      }
      var spacer = label.previousElementSibling;
      if (spacer && spacer.classList.contains('label-spacer')) {
        spacer.style.display = show ? '' : 'none';
      }
    });
  }

  function addCouponStyleOnce(couponName) {
    if (!couponName || styleCouponsAdded[couponName]) return;
    styleCouponsAdded[couponName] = true;
    var style = document.createElement('style');
    style.innerHTML = '.' + couponName.replace(/[^\w-]/g, '\\$&') + ' { display: inline-block !important; padding: 3px 15px; font-size: 14px; }';
    document.head.appendChild(style);
  }

  function processCard(card, raw, ref, logFirst) {
    if (!raw) return;
    var coupons = [];
    try {
      coupons = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!Array.isArray(coupons) || coupons.length === 0) {
      if (!ref) setLabelVisibility(card, null);
      return;
    }
    if (ref) {
      var selectedRef = coupons.find(function (aff) {
        return aff.coupon_name && String(aff.coupon_name).toLowerCase() === ref.toLowerCase();
      });
      if (logFirst) log('이 ref와 매칭된 selectedRef=', selectedRef);
      if (selectedRef) {
        card.setAttribute('data-ref-cookie', selectedRef.coupon_name);
        addCouponStyleOnce(selectedRef.coupon_name);
        setLabelVisibility(card, ref);
      } else {
        setLabelVisibility(card, null);
      }
    } else {
      setLabelVisibility(card, null);
    }
  }

  function run() {
    debug = checkDebug();
    var ref = getRef();
    var scripts = document.querySelectorAll('script[data-affiliate-coupons-json]');
    var cardsWithAttr = document.querySelectorAll('product-card[data-affiliate-coupons]');

    log('ref=', ref, '| script 개수=', scripts.length, '| data-affiliate-coupons 카드=', cardsWithAttr.length);

    if (debug && (scripts.length > 0 || cardsWithAttr.length > 0)) {
      var firstRaw = scripts.length > 0
        ? (scripts[0].textContent || '').trim()
        : decodeAttrJson(cardsWithAttr[0].getAttribute('data-affiliate-coupons') || '');
      log('첫 데이터(앞 200자)=', (firstRaw || '').substring(0, 200));
      try {
        var parsed = firstRaw ? JSON.parse(firstRaw) : [];
        log('첫 카드 파싱된 coupons=', parsed);
        var firstCard = scripts.length > 0 ? scripts[0].closest('product-card') : cardsWithAttr[0];
        if (firstCard) {
          var labelsInFirst = firstCard.querySelectorAll('.grid-view-ref-special-label[data-coupon-name]');
          log('첫 카드 내 라벨 개수=', labelsInFirst.length);
          labelsInFirst.forEach(function (l, i) {
            log('  라벨[' + i + '] data-coupon-name=', l.getAttribute('data-coupon-name'));
          });
        }
      } catch (e) {
        log('첫 카드 JSON 파싱 에러', e);
      }
    }

    if (scripts.length > 0) {
      scripts.forEach(function (script) {
        var card = script.closest('product-card');
        if (!card) return;
        processCard(card, (script.textContent || '').trim(), ref, debug && script === scripts[0]);
      });
    } else {
      cardsWithAttr.forEach(function (card) {
        var raw = card.getAttribute('data-affiliate-coupons');
        if (!raw) return;
        processCard(card, decodeAttrJson(raw), ref, debug && card === cardsWithAttr[0]);
      });
    }

    if (!ref) {
      var allCards = document.querySelectorAll('product-card');
      allCards.forEach(function (card) {
        var labels = card.querySelectorAll('.grid-view-ref-special-label[data-coupon-name]');
        labels.forEach(function (label) {
          label.style.setProperty('display', 'none', 'important');
          var spacer = label.previousElementSibling;
          if (spacer && spacer.classList.contains('label-spacer')) spacer.style.display = 'none';
        });
      });
    }

    log('run() 완료');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
